import React, { useEffect, useState } from 'react';
import TranslationEquivalent from './TranslationEquivalent';
import { getDictionaryOrder } from '../Terms/TermDictionaries/TermDictionaries';
import Spinner from 'react-bootstrap/Spinner';
import { useLoadParserData, useParser } from './useParser';
import MandalaSkeleton from '../common/MandalaSkeleton';
import { useDictionaryStore } from '../../hooks/useDictionaryStore';
import { Link } from 'react-router-dom';

export default function TranslationResults({ data }) {
    const { parser } = useDictionaryStore();

    // console.log('data in trans results', data);
    const [dorder, setDOrder] = useState({});

    // console.log('Data in results', data);
    useEffect(() => {
        getDictionaryOrder().then((data) => setDOrder(data));
    }, []);

    let results = false;
    if (data) {
        if (parser === 'php') {
            if ('parsed' in data) {
                results = data['parsed'].map((item, n) => (
                    <TranslationEquivalent
                        key={[item.id, n]}
                        lookup={`${item.tibetan}:${item.id}`}
                        dictmeta={dorder}
                    />
                ));
            }
        } else {
            if (data?.words) {
                results = Object.keys(data.words).map((w, n) => {
                    const tid =
                        data.words[w].length === 0 ? 'nf' : data.words[w][1];
                    const lu = w + ':' + tid;
                    return (
                        <TranslationEquivalent
                            key={[tid, n]}
                            lookup={lu}
                            dictmeta={dorder}
                        />
                    );
                });
            }
        }
    }

    const parsermsg =
        parser === 'php' ? (
            <p>Be patient... The PHP parser is slower...</p>
        ) : null;
    return (
        <div className="results-wrap">
            <h2>Results</h2>
            <div id="results">
                {!results && (
                    <div className="spinner-wrap">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        {parsermsg}
                    </div>
                )}
                {results}
            </div>
        </div>
    );
}

// I believe this is deprecated
function LoadTranslations({ data, dictmeta }) {
    const {
        isLoading: isParserLoading,
        data: results,
        isError: isParsingError,
        error: parseError,
    } = useParser(data);

    if (isParserLoading) {
        return <MandalaSkeleton />;
    }

    // Stop the cycle when there are no more words returned.
    if (!results?.words) {
        return null;
    }

    // Map words to trnaslation equivalents
    const transequivs = results?.words?.map((w, n) => {
        return (
            <TranslationEquivalent
                key={[w, n]}
                lookup={w}
                dictmeta={dictmeta}
            />
        );
    });

    return (
        <>
            {transequivs}
            {results?.undone?.length > 0 && (
                <LoadTranslations data={results} dictmeta={dictmeta} />
            )}
        </>
    );
}
